import React from 'react';

interface LoadingStateProps {
  message?: string;
}

const LoadingState: React.FC<LoadingStateProps> = ({
  message = 'Loading...',
}) => {
  return (
    <div className="onboarding-loading">
      <div className="loading-spinner">
        <div className="spinner-ring" />
      </div>
      <p className="loading-message">{message}</p>
    </div>
  );
};

export default LoadingState;
